<template>
	<div class='con_comment_detail'>
		<code-login ref="myCodeLogin" @update-page="updatePage"></code-login>
		<head-top head-title="评论详情" goBack="true"></head-top>

		<div class="comment_detail bg_a">
			<!-- 状态角标 status=>1:待审核，2：通过，3：未通过-->
			<div class="comment_detail_statusIcon">
				<img :src='require("../../assets/img/books/daish.png")' v-if="commentDetail.status==1">
				<img :src='require("../../assets/img/books/ysh.png")' v-if="commentDetail.status==2">
				<img :src='require("../../assets/img/books/shbtg.png")' v-if="commentDetail.status==3">
			</div>

			<!-- 头像，昵称，发表时间,删帖 -->
			<div class="flex_c comment_detail_userinfo">
				<img v-if="commentDetail.user" :src='commentDetail.user.customAvatar?resourceDomain+commentDetail.user.customAvatar:default_avatar' class="comment_detail_default_avatar">
				<div class="flex_c comment_detail_userright" v-if="commentDetail.user">
					<div class="color_a font_size_c ellipsis_1" style="width:100%;">{{commentDetail.user.realName?commentDetail.user.realName:commentDetail.user.loginAccount}}</div>
					<div class="color_e font_size_b ellipsis_1" style="width:100%;">{{commentDetail.createTime}}</div>
				</div>

			</div>

			<!-- 图书 -->
			<div class="color_f font_size_b comment_detail_book" @click="toBooksDetail(commentDetail.bookId)">
				<div class="ellipsis_2">{{commentDetail.bookName}}</div>
			</div>

			<!-- 评论-文字 -->
			<div class="color_a font_size_c comment_detail_txt">
				<div v-html="commentDetail.comment?commentDetail.comment:'用户未填写评价'"></div>
			</div>

			<!-- 评论-多图 -->
			<div class="flex_a comment_detail_imgs" v-if="commentDetail.imgs">
				<div v-for="(t,idx) in commentDetail.imgs.split(',')" :key='idx' class="comment_detail_img_item">
					<img :src='resourceDomain+t' v-if="t" @click="previewImages(commentDetail.imgs.split(','),idx)"></img>
				</div>
			</div>

			<div class="flex_a font_size_b comment_detail_btns" style="width: 100%;justify-content: flex-end;" v-if="commentDetail.canDelete">
				<!-- 删帖 -->
				<div class="flex_a color_d" @click="removeComment(commentDetail.id)">
					<img :src='resourceDomain+"static/icon/clear-his.png"'>
					<div>删除</div>
				</div>
			</div>
		</div>

		<!-- 回复 -->
		<div class="bg_a comment_detail margin_top_c" v-if="commentDetail.officialStatus">
			<div class="flex_a">
				<div class="comment_reply_titleLine bg_b"></div>
				<div class="comment_reply_title">客服回复</div>
			</div>
			<!-- 回复内容 -->
			<div class="comment_reply_detail font_size_a color_f" v-html="commentDetail.officialReply"></div>
		</div>
	</div>
</template>

<script>
	import headTop from '@/components/common/head.vue'
	import api from '@/apis/api'
	import {
		mapGetters,
		mapActions
	} from 'vuex';
	import {
		ImagePreview
	} from 'vant';
	export default {
		name: 'CommentList',
		components: {
			headTop: headTop
		},
		data() {
			return {
				default_avatar: "https://wenwu3.oss-cn-hangzhou.aliyuncs.com/static/default_avatar.jpg", //默认头像
				resourceDomain: api.resourceDomain,
				commentDetail: {},
				id: undefined
			}
		},
		beforeRouteEnter(to, from, next) {
			// 添加背景色
			document.querySelector('body').setAttribute('style', 'background-color:#f5f5f5')
			next()
		},
		beforeRouteLeave(to, from, next) {
			// 去除背景色
			document.querySelector('body').setAttribute('style', '')
			next()
		},
		created() {
			this.id = this.$route.query.id
			this.updatePage()
		},

		computed: {
			...mapGetters('userModule', ['getToken'])
		},

		methods: {
			...mapActions("userModule", ["SET_OPENID"]),

// 调用组件中的登录成功里的自定义的更新数据事件
			updatePage() {
				window.scrollTo(0, 0);
				this.getOneCommentById()
			},
			
			// 获取评论详情
			getOneCommentById() {
				let url = this.getToken() ? `/book/comment/getOneCommentByIdHasUserId/${this.id} ` :
					`/p/book/comment/getOneCommentById/${this.id}`
				this.$toast.loading({
					overlay: true,
					message: '加载中...',
					duration: 0
				})

				api.post(url, {}).then(res => {
					this.$toast.clear()
					console.log(res, "-----getOneCommentById-----")
					if (res.success) {
						this.commentDetail = res.data
					} else {
						this.$dialog.alert({
							title: '提示',
							message: "该评论异常，请返回重试"
						}).then(() => {
							this.$router.go(-1)
						});
					}
				})
			},

			// 预览评论的多图
			previewImages(images, idx) {
				images.forEach((value, index) => {
					images[index] = this.resourceDomain + value
				});
				ImagePreview({
					images: images,
					startPosition: idx,
					loop: false
				});
			},

			// 删除评论并返回列表
			removeComment(id) {
				this.$toast.loading({
					overlay: true,
					message: '删除中...',
					duration: 0
				})

				api.post(`/book/comment/removeById/${id}`, {}).then(res => {
					this.$toast.clear()
					console.log(res, "-----removeById------")
					if (res.success) {
						this.$toast.success({
							message: '删除成功!',
							forbidClick: true,
							duration: 2000
						});
						setTimeout(() => {
							this.$router.go(-1)
						}, 2000);

					} else {
						this.$toast.fail("删除失败，请刷新重试");
					}
				})

			},


			//跳转图书详情
			toBooksDetail(bookId) {
				this.$router.push({
					'path': '/book_detail',
					query: {
						bookId: bookId
					}
				})
			},
		}
	}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
	.main_comment {
		padding: 45px 0 15px;
	}

	.comment_detail {
		width: 345px;
		padding: 15px;
	}

	.comment_detail_statusIcon {
		width: 60px;
		height: 62px;
		right: 0;
		top: 48px;
		z-index: 1;
		position: absolute;
	}

	.comment_detail_statusIcon img {
		display: block;
		width: 100%;
		height: 100%;
		overflow: hidden;
	}

	.con_comment_detail {
		padding-top: 48px;
	}

	.comment_detail_userinfo {
		width: 345px;
		height: 40px;
		margin-bottom: 10px;
	}

	.comment_detail_default_avatar {
		width: 40px;
		height: 40px;
		border-radius: 20px;
	}

	.comment_detail_userright {
		width: 290px;
		height: 40px;
		flex-direction: column;
	}

	.comment_detail_book {
		background-color: #f4f4f4;
		width: 325px;
		padding: 8px 10px;
		margin-bottom: 10px;
	}

	.comment_detail_txt {
		letter-spacing: 1px;
		line-height: 1.4;
		white-space: pre-wrap;
	}

	.comment_detail_imgs {
		width: 100%;
		flex-wrap: wrap;
		padding-top: 12px;
	}

	.comment_detail_img_item {
		margin-right: 15px;
		margin-bottom: 10px;
		width: 105px;
		height: 105px;
	}

	.comment_detail_img_item:nth-child(3n) {
		margin-right: 0 !important;
	}

	.comment_detail_img_item img {
		width: 105px;
		height: 105px;
		display: block;
		overflow: hidden;
		object-fit: cover;
	}

	.comment_detail_btns {
		padding-top: 10px;
	}

	.comment_detail_btns img {
		display: block;
		width: 20px;
		height: 20px;
		margin-right: 5px;
	}

	.margin_top_c {
		margin-top: 10px;
	}

	.comment_reply_titleLine {
		width: 5px;
		height: 22px;
		border-radius: 2.5px;
		margin-right: 10px;
	}

	.comment_reply_title {
		line-height: 22px;
		font-size: 18px;
	}

	.comment_reply_detail {
		margin-top: 15px;
		padding-top: 10px;
		border-top: 1px solid #eee;
		letter-spacing: 1px;
		line-height: 1.5;
		white-space: pre-wrap;
	}
</style>
